<h2 mat-dialog-title>Apply minimum questions for {{ data.methodologyName }}</h2>
<mat-dialog-content>
  <p>
    Questions required for {{ data.methodologyName }} stay. Questions used in populations, packages, tables, or formulas stay.
    Every other draft question is removed. This updates the draft for this aid year and does not publish it.
  </p>
  <div class="minimum-questions-dialog__columns">
    <section aria-labelledby="minimum-questions-adding">
      <h3 id="minimum-questions-adding">Adding ({{ data.added.length }})</h3>
      @if (data.added.length === 0) {
        <p>None</p>
      } @else {
        <ul class="minimum-questions-dialog__list">
          @for (id of data.added; track id) {
            <li><code>{{ id }}</code></li>
          }
        </ul>
      }
    </section>
    <section aria-labelledby="minimum-questions-removing">
      <h3 id="minimum-questions-removing">Removing ({{ data.removed.length }})</h3>
      @if (data.removed.length === 0) {
        <p>None</p>
      } @else {
        <ul class="minimum-questions-dialog__list">
          @for (id of data.removed; track id) {
            <li><code>{{ id }}</code></li>
          }
        </ul>
      }
    </section>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" mat-button (click)="dialogRef.close(false)">Cancel</button>
  <button type="button" mat-flat-button color="primary" (click)="dialogRef.close(true)">Apply</button>
</mat-dialog-actions>
